// extracted by mini-css-extract-plugin
export default {"container":"ProjectDetailsTab_container__P6e9M","addProjectForm":"ProjectDetailsTab_addProjectForm__10hN0","projectCard":"ProjectDetailsTab_projectCard__JvP0H"};